<div class="grid form-group">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <app-loading *ngIf="guardando"></app-loading>
    <div *ngIf="!guardando && !carInformacionInicial">
      <p-pickList [source]="actFuente" [target]="actSeleccionadas"
                  sourceHeader="{{'SEGMENTOSACTIVIDADES.LBL_ACTIVIDADESDISPONIBLES'|translate}}"
                  targetHeader="{{'SEGMENTOSACTIVIDADES.LBL_ACTIVIDADESSELECCIONADAS'|translate}}"
                  (onMoveToTarget)="guardar($event.items, true)"
                  (onMoveToSource)="guardar($event.items, false)"
                  (onMoveAllToTarget)="guardar($event.items, true)"
                  (onMoveAllToSource)="guardar($event.items, false)"
                  [showTargetControls]="false"
                  [showSourceControls]="false"
                  filterBy="actividadEconomica">
        <ng-template let-actividad pTemplate="item">
          <div class="p-helper-clearfix">
            {{actividad.codigoActividadEconomica}}-{{actividad.actividadEconomica}}
          </div>
        </ng-template>
      </p-pickList>
    </div>
    <div *ngIf="guardando && carInformacionInicial">
      <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
      <span>{{'LBL_GUARDANDO' | translate }}</span>
    </div>
  </div>

</div>
